export default __webpack_public_path__ + "static/media/oprah-winfrey.9e3add79.png";